<app-modal (dismissed)="onCloseClick()" width="min(1180px, calc(100vw - 40px))">
    <div class="car-dialog">
        <header class="dialog-header">
            <div>
                <span class="eyebrow">{{ 'Car Details' | translate }}</span>
                @if (!isNullOrUndefined(carDetails)) {
                    <h2>{{ carDetails | carDisplay }}</h2>
                }
            </div>
            <button (click)="onCloseClick()" [attr.aria-label]="'Close car details' | translate"
                    [title]="'Close' | translate" class="icon-button"
                    type="button">
                <i class="material-icons">close</i>
            </button>
        </header>

        @if (!isNullOrUndefined(carDetails)) {
            <div class="dialog-body">
                <section class="detail-grid">
                    <div class="detail-panel">
                        <h3>{{ 'Vehicle' | translate }}</h3>
                        <dl>
                            <div>
                                <dt>{{ 'Car Number' | translate }}</dt>
                                <dd>{{ carDetails.CarNumber }}</dd>
                            </div>
                            <div>
                                <dt>{{ 'Car Model' | translate }}</dt>
                                <dd>{{ carDetails.CarModel }}</dd>
                            </div>
                            @if (!isNullOrUndefined(carDetails.CarDetails)) {
                                <div>
                                    <dt>{{ 'Authorization' | translate }}</dt>
                                    <dd>{{ carDetails.CarDetails.Authorization }}</dd>
                                </div>
                            }
                            <div>
                                <dt>{{ 'Last Login' | translate }}</dt>
                                <dd>{{ (carDetails.LastLoginAsString || 'never') | translate }}</dd>
                            </div>
                        </dl>
                    </div>
                    <div class="detail-panel actions-panel">
                        <h3>{{ 'Services' | translate }}</h3>
                        <div class="status-line">
                            <span>{{ 'Pairing' | translate }}</span>
                            @if (!shouldUnpairBeVisible) {
                                <strong
                                        class="danger-text">{{ 'Ready to pair' | translate }}</strong>
                            }
                            @if (shouldUnpairBeVisible) {
                                <strong>{{ 'Paired' | translate }}</strong>
                            }
                        </div>
                        @if (shouldUnpairBeVisible && canUnpairDevice) {
                            <button (click)="showUnpairDeviceDialog()"
                                    [title]="'Unpair device' | translate"
                                    class="btn btn-sm btn-info" type="button">{{ 'Unpair' | translate }}
                            </button>
                        }
                        <div class="status-line">
                            <span>Drink Safe</span>
                            <strong>{{ carDetails.Services.HasAccessToDrinkSafe }}</strong>
                        </div>
                        @if (canUpdateCar) {
                            <button (click)="testNewBtn()" class="btn btn-sm btn-info"
                                    type="button">Drink Safe
                            </button>
                        }
                        <div class="status-line">
                            <span>{{ 'Package' | translate }}</span>
                            <strong class="success-text">{{ carDetails.Services.Package }}
                                ({{ carDetails.CarPreferences.PricePerKm }})</strong>
                        </div>
                        @if (canUpdateCar) {
                            <button (click)="selectPackage()" class="btn btn-sm btn-info"
                                    type="button">{{ 'Select package' | translate }}
                            </button>
                        }
                    </div>
                </section>
                <section class="detail-panel suspension-panel">
                    <div>
                        <h3>{{ 'Suspension' | translate }}</h3>
                        <div class="status-line inline">
                            <span>{{ 'Status' | translate }}</span>
                            @if (!carDetails.Suspension.IsSuspended) {
                                <strong
                                        class="success-text">{{ 'No' | translate }}</strong>
                            }
                            @if (carDetails.Suspension.IsSuspended) {
                                <strong
                                        class="danger-text">{{ 'Yes' | translate }}</strong>
                            }
                        </div>
                        @if (carDetails.Suspension.IsSuspended) {
                            <div class="suspension-meta">
                                <span>{{ 'Until' | translate }} {{ carDetails.Suspension.SuspensionUntilDate_iso | date: 'dd.MM.yyyy HH:mm' }}</span>
                                <span>{{ carDetails.Suspension.Reason }}</span>
                            </div>
                        }
                    </div>
                    <div class="button-row">
                        @if (canSuspendCar) {
                            <button (click)="suspendCar()" class="btn btn-sm btn-danger"
                                    type="button">{{ 'Suspend' | translate }}
                            </button>
                        }
                        @if (canUnsuspendCar) {
                            <button (click)="unsuspendCar()" class="btn btn-sm btn-success"
                                    type="button">{{ 'Unsuspend' | translate }}
                            </button>
                        }
                    </div>
                </section>
                <section class="detail-panel">
                    <h3>{{ 'Drivers' | translate }}</h3>
                    <div class="drivers-grid">
                        @for (driver of carDetails.Drivers; track driver) {
                            <div class="driver-card">
                                <button (click)="onDriverSelected(driver.DriverIdentifier)" class="driver-select-button"
                                        type="button">
                                    <img class="img-fluid imgDriverSize"
                                         (error)="useFallbackDriverImage($event)"
                                         [alt]="driver.DriverName || ('Driver' | translate)"
                                         src="{{baseUrlForImages}}{{driver.DriverPicture}}">
                                    <span class="driver-name">{{ driver.DriverName }}</span>
                                </button>
                                @if (getDriverPhone(driver) !== '') {
                                    <div class="driver-phone-line">
                                        <span>{{ getDriverPhone(driver) }}</span>
                                        <a [href]="'tel:' + getDriverPhone(driver)" [title]="'Call driver' | translate"
                                           class="call-button">
                                            <i class="material-icons">phone</i>
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </section>
                @if (canSendCarMessage) {
                <section class="message-panel">
                    <div class="message-panel-heading">
                        <i class="material-icons">campaign</i>
                        <div>
                            <h2>{{ 'Message This Car' | translate }}</h2>
                            <p>{{ 'This notification will be sent only to this car.' | translate }}</p>
                            <strong>{{ carDetails | carDisplay }}</strong>
                        </div>
                    </div>

                    <form #carMessageForm="ngForm"
                          (ngSubmit)="sendNotificationToCar(carMessageForm)"
                          class="message-form">
                        <label>
                            <span>{{ 'Notification title' | translate }}</span>
                            <input [(ngModel)]="pushTitle" [disabled]="isSendingPush" autocomplete="off"
                                   maxlength="100" name="pushTitle" required>
                            <small>{{ pushTitle.length }} / 100</small>
                        </label>

                        <label>
                            <span>{{ 'Message' | translate }}</span>
                            <textarea [(ngModel)]="pushMessage" [disabled]="isSendingPush" maxlength="1000"
                                      name="pushMessage" required rows="7"></textarea>
                            <small>{{ pushMessage.length }} / 1000</small>
                        </label>

                        @if (pushSuccessMessage !== '') {
                            <div class="message-status success" role="status">
                                <i class="material-icons">check_circle</i>
                                <span>{{ pushSuccessMessage | translate }}</span>
                            </div>
                        }
                        @if (pushErrorMessage !== '') {
                            <div class="message-status error" role="alert">
                                <i class="material-icons">error</i>
                                <span>{{ pushErrorMessage | translate }}</span>
                            </div>
                        }

                        <div class="message-actions">
                            <button [disabled]="isSendingPush || carMessageForm.invalid"
                                    class="send-message-button" type="submit">
                                <i [class.spinning]="isSendingPush" class="material-icons">
                                    {{ isSendingPush ? 'refresh' : 'send' }}
                                </i>
                                <span>{{ (isSendingPush ? 'Sending...' : 'Send to car') | translate }}</span>
                            </button>
                        </div>
                    </form>
                </section>
                }
            </div>
        }
    </div>
</app-modal>

@if (notificationMessage) {
    <div [class]="'app-toast app-toast--' + notificationType" role="status">
    <i class="material-icons">add_alert</i>
    <span>{{ notificationMessage }}</span>
    </div>
}

<ng-template #dialogsContainer2></ng-template>
